export const responseDataPermissionUsingRole: any = {
    'admin': {
        "user_locations": {
            "stateCodes": null,
            "districts": null
        },
        "user_role": [
            {
                "role_slug": "admin"
            }
        ],
        "user_department": [],
        "user_type": [],
        "user_number": [],
        "user_role_permission": [
            {
                "uuid": "dashboard123",
                "parent_id": "0",
                "name": "Dashboard",
                "slug": "dashboard",
                "module_url": "/admin/dashboard",
                "icon": "Dashboard",
                "module_order": "1",
                "is_navigation": 1,
            },
            {
                "uuid": "callsdetailsmaster123",
                "parent_id": "0",
                "name": "Find Care",
                "slug": "CallsDetails",
                "module_url": "/admin/calls",
                "icon": "PermPhoneMsgOutlined",
                "module_order": "2",
                "is_navigation": 1,
            },
            {
                "uuid": "callsdetailss123",
                "parent_id": "callsdetailsmaster123",
                "name": "Calls Dashboard",
                "slug": "CallsDetails",
                "module_url": "/admin/calls",
                "icon": "SpaceDashboard",
                "module_order": "2",
                "is_navigation": 1,
            },
            {
                "uuid": "searchhospitals123",
                "parent_id": "callsdetailsmaster123",
                "name": "Search Hospitals",
                "slug": "searchhospitals",
                "module_url": "/admin/search-hospitals",
                "icon": "ManageSearchOutlined",
                "module_order": "3",
                "is_navigation": 1,
            },  
            {
                "uuid": "beneficiaryList123",
                "parent_id": "callsdetailsmaster123",
                "name": "Beneficiary List",
                "slug": "beneficiaryList",
                "module_url": "/admin/call-beneficiaries",
                "icon": "PeopleOutlineOutlined",
                "module_order": "3",
                "is_navigation": 1,
            },  
            {
                "uuid": "hospitalList123",
                "parent_id": "0",
                "name": "Hospitals",
                "slug": "hospitalList",
                "module_url": "/admin/hospitals",
                "icon": "BusinessOutlined",
                "module_order": "5",
                "is_navigation": 1,
            },
            {
                "uuid": "bloodbanklist23",
                "parent_id": "0",
                "name": "Blood Banks",
                "slug": "bloodbanklist",
                "module_url": "/admin/blood-banks",
                "icon": "BloodtypeOutlined",
                "module_order": "6",
                "is_navigation": 1,
            },
            {
                "uuid": "schemesList123",
                "parent_id": "0",
                "name": "Schemes Master",
                "slug": "schemesList",
                "module_url": "/admin/scheme-list",
                "icon": "FormatListBulletedOutlined",
                "module_order": "7",
                "is_navigation": 1,
            },
            {
                "uuid": "visitorslist123",
                "parent_id": "0",
                "name": "WhatsApp User Visits",
                "slug": "visitors_list",
                "module_url": "/admin/whatsapp-visitors",
                "icon": "SupervisedUserCircleOutlined",
                "module_order": "8",
                "is_navigation": 1,
            },
            {
                "uuid": "userList123",
                "parent_id": "0",
                "name": "System Users",
                "slug": "userList",
                "module_url": "/admin/user-list",
                "icon": "GroupsOutlined",
                "module_order": "9",
                "is_navigation": 1,
            },
        ]
    },
    'agent': {
        "user_locations": {
            "stateCodes": null,
            "districts": null
        },
        "user_role": [
            {
                "role_slug": "agent"
            }
        ],
        "user_department": [],
        "user_type": [],
        "user_number": [],
        "user_role_permission": [
            {
                "uuid": "searchhospitals123",
                "parent_id": "0",
                "name": "Search Hospitals",
                "slug": "searchhospitals",
                "module_url": "/agent/search-hospitals",
                "icon": "ManageSearchOutlined",
                "module_order": "3",
                "is_navigation": 1,
            },
            {
                "uuid": "callsdetailss123",
                "parent_id": "0",
                "name": "Calls Dashboard",
                "slug": "CallsDetails",
                "module_url": "/agent/calls",
                "icon": "PermPhoneMsgOutlined",
                "module_order": "2",
                "is_navigation": 1,
            },
            {
                "uuid": "beneficiaryList123",
                "parent_id": "0",
                "name": "Beneficiary List",
                "slug": "beneficiaryList",
                "module_url": "/agent/call-beneficiaries",
                "icon": "PeopleOutlineOutlined",
                "module_order": "3",
                "is_navigation": 1,
            },
        ]
    },
    'hospital': {
        "user_locations": { "stateCodes": null, "districts": null },
        "user_role": [{ "role_slug": "hospital" }],
        "user_department": [],
        "user_type": [],
        "user_number": [],
        "user_role_permission": [
            {
                "uuid": "hospitalProfile123",
                "parent_id": "0",
                "name": "Profile",
                "slug": "profile",
                "module_url": "/admin/profile",
                "icon": "AccountCircleOutlined",
                "module_order": "1",
                "is_navigation": 1,
            },
        ]
    },
    'blood_bank': {
        "user_locations": { "stateCodes": null, "districts": null },
        "user_role": [{ "role_slug": "blood_bank" }],
        "user_department": [],
        "user_type": [],
        "user_number": [],
        "user_role_permission": [
            {
                "uuid": "bloodBankProfile123",
                "parent_id": "0",
                "name": "Profile",
                "slug": "profile",
                "module_url": "/admin/profile",
                "icon": "AccountCircleOutlined",
                "module_order": "1",
                "is_navigation": 1,
            },
        ]
    }
}
